import { formatCHF } from "@/lib/format";
import { formatVatRate, validPriceTax } from "@/lib/priceTax";

// Only persisted/server-provided tax snapshots may describe an offer or charge.
export default function CustomerTaxBreakdown({ tax, title, totalLabel = "Totale IVA inclusa", testId = "customer-tax-breakdown", className = "" }) {
  if (!validPriceTax(tax)) return null;
  return (
    <div className={`space-y-1 text-xs ${className}`} data-testid={testId}>
      {title && <p className="font-semibold">{title}</p>}
      <dl className="grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 gap-y-1">
        <dt>Imponibile (IVA esclusa)</dt><dd className="text-right tabular-nums">{formatCHF(tax.net_chf)}</dd>
        <dt>IVA {formatVatRate(tax.vat_rate)}</dt><dd className="text-right tabular-nums">{formatCHF(tax.vat_chf)}</dd>
        <dt className="font-semibold">{totalLabel}</dt><dd className="text-right font-semibold tabular-nums">{formatCHF(tax.total_chf)}</dd>
      </dl>
    </div>
  );
}
